// import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

export default function Welcome({user, userData}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const agency = userData
    ? userData.agencyInfo
      ? userData.agencyInfo.name
      : t("welcome.defaultAgency")
    : t("welcome.defaultAgency");
  const email =
    userData && userData.agencyInfo ? userData.agencyInfo.email : "<Error>";

  return (
    <>
      {/* Instructions  */}
      <section className="main-section">
        <h2>{t("welcome.title")}</h2>
        <div className="main-section-content text-start">
          <p>
            <Trans
              i18nKey="welcome.thankYou"
              t={t}
              values={{ agency }}
              components={{ strong: <strong /> }}
            />
          </p>
          <p>{t("welcome.walkThrough")}</p>
          <p>{t("welcome.checklistIntro")}</p>
          <p>{t("welcome.phases")}</p>
          <p>{t("welcome.navigation")}</p>

          <p>
            <Trans
              i18nKey="welcome.contact"
              t={t}
              values={{ email }}
              components={{ b: <b /> }}
            />
          </p>
        </div>
      </section>

      {/* Checklist  */}
      <section className="main-section">
        <h2>{t("welcome.checklist")}</h2>
        <div className="main-section-content">
          <h3>{t("welcome.information")}</h3>
          <ul className="text-start">
            <li>{t("welcome.info.personalInfo")}</li>
            <li>{t("welcome.info.residenceHistory")}</li>
            <li>{t("welcome.info.employmentHistory")}</li>
            <li>{t("welcome.info.references")}</li>
            <li>{t("welcome.info.education")}</li>
          </ul>
          <h3>{t("welcome.documents")}</h3>
          <ul className="text-start">
            <li>{t("welcome.docs.license")}</li>
            <li>{t("welcome.docs.ssCard")}</li>
            <li>{t("welcome.docs.tbTest")}</li>
            <li>{t("welcome.docs.covidCard")}</li>
            <li>{t("welcome.info.education")}</li>
          </ul>
          <h3>{t("welcome.miscellaneous")}</h3>
          <ul className="text-start">
            <li>{t("welcome.misc.mobileAccess")}</li>
          </ul>
          <Button onClick={() => navigate(`../phase1-personal-information`)}>
            {t("common.next")}
          </Button>
        </div>
      </section>
    </>
  );
}
